import Swiper from "swiper/bundle";

jQuery(document).ready(function ($) {

  var initializeAndBindSwipers = function () {
    // Always query fresh — never use a stale outer-scope reference
    var mainSwiperElement = $(".rtwpvg-slider")[0];
    var thumbSwiperElement = $(".rtwpvg-thumbnail-slider")[0];

    if (!mainSwiperElement) return;

    const realSlideCount = mainSwiperElement.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    ).length;

    if (realSlideCount <= 1) {
      $(".variations-swiper-prev, .variations-swiper-next").hide();
    } else {
      $(".variations-swiper-prev, .variations-swiper-next").show();
    }

    // Initialize Main Swiper if not already
    let mainSwiperInstance = mainSwiperElement.swiper;
    if (!mainSwiperInstance) {
      const mainOptions = JSON.parse(mainSwiperElement.dataset.options);
      mainOptions.navigation = {
        nextEl: ".variations-swiper-next",
        prevEl: ".variations-swiper-prev",
        disabledClass: "swiper-button-disabled",
      };
      mainSwiperInstance = new Swiper(mainSwiperElement, mainOptions);
      if (mainSwiperInstance.navigation) {
        mainSwiperInstance.navigation.update();
      }
    }
    if (!mainSwiperInstance) return;

    // Initialize Thumbnail Swiper if not already
    let thumbSwiperInstance = thumbSwiperElement?.swiper;
    if (!thumbSwiperInstance && thumbSwiperElement) {
      const thumbOptions = JSON.parse(thumbSwiperElement.dataset.options);
      thumbOptions.slidesPerView = thumbOptions.breakpoints?.["0"]?.slidesPerView || 3;
      thumbOptions.slidesPerGroup = thumbOptions.breakpoints?.["0"]?.slidesPerGroup || 1;
      thumbOptions.spaceBetween = 10;
      thumbOptions.loop = false;
      thumbOptions.freeMode = true;
      thumbOptions.watchSlidesProgress = true;
      thumbOptions.watchSlidesVisibility = true;
      thumbOptions.navigation = {
        nextEl: ".thumbnail-gallery-swiper-next",
        prevEl: ".thumbnail-gallery-swiper-prev",
        disabledClass: "swiper-button-disabled",
      };
      thumbSwiperInstance = new Swiper(thumbSwiperElement, thumbOptions);
    }

    var updateMainNavigationState = function () {
      $(".variations-swiper-prev")
        .removeClass("swiper-button-disabled")
        .toggleClass("swiper-button-disabled", mainSwiperInstance.isBeginning);
      $(".variations-swiper-next")
        .removeClass("swiper-button-disabled")
        .toggleClass("swiper-button-disabled", mainSwiperInstance.isEnd);
    };

    var updateThumbnailNavigationState = function () {
      if (!thumbSwiperInstance) return;
      $(".thumbnail-gallery-swiper-prev")
        .removeClass("swiper-button-disabled")
        .toggleClass("swiper-button-disabled", thumbSwiperInstance.isBeginning);
      $(".thumbnail-gallery-swiper-next")
        .removeClass("swiper-button-disabled")
        .toggleClass("swiper-button-disabled", thumbSwiperInstance.isEnd);
    };

    var updateThumbnailsActiveState = function () {
      var thumbs = $(".rtwpvg-thumbnail-image");
      thumbs.removeClass("swiper-slide-thumb-active");
      var activeIndex = mainSwiperInstance.realIndex;
      thumbs.eq(activeIndex).addClass("swiper-slide-thumb-active");
      if (thumbSwiperInstance) {
        thumbSwiperInstance.slideTo(activeIndex);
      }
    };

    // Main slider nav
    $(".variations-swiper-prev").off("click").on("click", function () {
      if (!$(this).hasClass("swiper-button-disabled")) {
        mainSwiperInstance.slidePrev();
        updateThumbnailsActiveState();
        setTimeout(updateMainNavigationState, 50);
      }
    });

    $(".variations-swiper-next").off("click").on("click", function () {
      if (!$(this).hasClass("swiper-button-disabled")) {
        mainSwiperInstance.slideNext();
        updateThumbnailsActiveState();
        setTimeout(updateMainNavigationState, 50);
      }
    });

    mainSwiperInstance.off("slideChange").on("slideChange", function () {
      updateThumbnailsActiveState();
      updateMainNavigationState();
    });

    mainSwiperInstance.off("transitionEnd").on("transitionEnd", function () {
      updateMainNavigationState();
    });

    // Thumbnail slider nav
    if (thumbSwiperInstance) {
      $(".thumbnail-gallery-swiper-prev").off("click").on("click", function () {
        if (!$(this).hasClass("swiper-button-disabled")) {
          thumbSwiperInstance.slidePrev();
          setTimeout(updateThumbnailNavigationState, 50);
        }
      });

      $(".thumbnail-gallery-swiper-next").off("click").on("click", function () {
        if (!$(this).hasClass("swiper-button-disabled")) {
          thumbSwiperInstance.slideNext();
          setTimeout(updateThumbnailNavigationState, 50);
        }
      });

      thumbSwiperInstance.off("slideChange").on("slideChange", updateThumbnailNavigationState);
      thumbSwiperInstance.off("transitionEnd").on("transitionEnd", updateThumbnailNavigationState);
    }

    //Thumbnail click — delegated to a stable parent wrapper so it
    // survives DOM replacement and does NOT depend on thumbSwiperInstance.
    // Using the swiper wrapper as the stable ancestor.
    var stableThumbParent = thumbSwiperElement
      ? thumbSwiperElement.querySelector(".swiper-wrapper")
      : null;

    if (stableThumbParent) {
      $(stableThumbParent).off("click.thumbClick").on("click.thumbClick", ".rtwpvg-thumbnail-image", function () {
        var allThumbs = $(".rtwpvg-thumbnail-image");
        var clickedIndex = allThumbs.index(this); // ✅ index among ALL thumbs, not just siblings
        if (clickedIndex === -1) return;

        if (mainSwiperInstance.params.loop) {
          mainSwiperInstance.slideToLoop(clickedIndex);
        } else {
          mainSwiperInstance.slideTo(clickedIndex);
        }

        updateThumbnailsActiveState();
        updateMainNavigationState();
      });
    }

    updateThumbnailsActiveState();
    updateMainNavigationState();
    updateThumbnailNavigationState();
  };


  // to ensure the plugin finishes its own re-render before we run
  setTimeout(initializeAndBindSwipers, 500);

  $("form.variations_form").on("found_variation", function () {
    setTimeout(initializeAndBindSwipers, 500); // ✅ was 200ms — too fast, race condition
  });
  const navButtons = document.querySelector(".product-variations-custom-swiper-navigation");
  const thumbnailSlideButtons = document.querySelector(".product-thumbnail-gallery-custom-swiper-navigation");
  const sliderWrapper = document.querySelector(".rtwpvg-slider-wrapper");
  const thumbnailSlideWrapper = document.querySelector(".rtwpvg-thumbnail-wrapper");

  if (navButtons && sliderWrapper) {
    sliderWrapper.appendChild(navButtons);
    navButtons.classList.remove("d-none");
  }

  if (thumbnailSlideButtons && thumbnailSlideWrapper) {
    thumbnailSlideWrapper.appendChild(thumbnailSlideButtons);
    thumbnailSlideButtons.classList.remove("d-none");
  }
});